module.exports = __webpack_public_path__ + "img/document.8f0e17ab.svg";